module.exports = __webpack_public_path__ + "img/SS.562eaa76.svg";